
import React, { memo } from 'react';
import PropTypes from 'prop-types';


import { ANNOTATION_NAMES_TO_COMPONENT } from './AnnotationNodes.constants';

const MemoizedAnnotation = ({
  annotation,
  annotationEvents,
  draggable,
}) => {
  const AnnotationComponent = ANNOTATION_NAMES_TO_COMPONENT[annotation.name];

  const { draggable: _ignoredDraggable, listening: storedListening, ...annotationProps } =
    annotation;
  // Pass-through card rects — clicks hit the text layer; padding uses bounds fallback.
  const listening =
    annotation.templateCardBackground === true
      ? false
      : storedListening !== false;

  return (
    <AnnotationComponent
      key={annotation.id}
      annotationEvents={annotationEvents}
      {...annotationProps}
      listening={listening}
      draggable={draggable}
    />
  );
};

MemoizedAnnotation.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  annotationEvents: PropTypes.instanceOf(Object).isRequired,
  draggable: PropTypes.bool.isRequired,
};

export default memo(MemoizedAnnotation);
